import { render, staticRenderFns } from "./appAssetList.vue?vue&type=template&id=6f8bcd66"
import script from "./appAssetList.vue?vue&type=script&lang=js"
export * from "./appAssetList.vue?vue&type=script&lang=js"
import style0 from "./appAssetList.vue?vue&type=style&index=0&id=6f8bcd66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports